<template>
  <section class="hk-watchlist">
    <header class="watchlist-heading"><span>我的自选股票</span><StockSearch compact /></header>
    <nav><button v-for="tab in availableTabs" :key="tab.market" type="button" :class="{ active: market === tab.market }" @click="$emit('market', tab.market)">{{ tab.label }}</button></nav>
    <div class="list-row watchlist-columns headings"><span>名称/代码</span><span>最新价</span><span>涨跌幅</span></div>
    <p v-if="error">{{ error }} <button type="button" @click="load">重试</button></p>
    <p v-else-if="!rows.length">{{ loading ? '加载中…' : '暂无自选股票，可通过顶部搜索选择' }}</p>
    <button v-for="row in rows" :key="row.full_code || row.symbol" class="list-row watchlist-columns" :class="{ active: row.full_code === selectedCode }" type="button" @click="$emit('select', row)"><span class="watchlist-identity" :title="row.name + ' [' + (row.full_code || row.symbol) + ']'"><span>{{ row.name }}</span><small>[{{ row.full_code || row.symbol }}]</small></span><span :title="price(row.last_px)">{{ price(row.last_px) }}</span><span :title="percent(row.px_change_rate)" :class="Number(row.px_change_rate) < 0 ? 'fall' : Number(row.px_change_rate) > 0 ? 'rise' : ''">{{ percent(row.px_change_rate) }}</span></button>
    <button v-if="hasMore" type="button" :disabled="loading" @click="load(true)">加载更多</button>
  </section>
</template>
<script>
import { quotePercent, quotePrice } from '@/utils/quoteDisplay'
import { marketEnabled } from '@/utils/systemConfig'
import { optionalNewApi } from '@/utils/requestapis'
import { getToken } from '@/utils/cache'
import StockSearch from '@/components/StockSearch.vue'
import { pollMarket } from '@/utils/marketRefresh'
import { refreshWatchlist } from '@/utils/workspaceQuotes'
import { sharedStockRows } from '@/utils/stockQuoteFeed'
export default {
  components: { StockSearch },
  computed: {
    availableTabs() { return this.tabs.filter(tab => marketEnabled(tab.market)) },
    rows: { get() { return sharedStockRows(this.rowsSnapshot, this.market) }, set(value) { this.rowsSnapshot = value } }
  },
  props: { market: String, selectedCode: String },
  data: () => ({ rowsSnapshot: [], page: 1, hasMore: false, loading: false, error: '', request: 0, tabs: [{ market: 'cn', label: '沪深' }, { market: 'hk', label: '港股' }, { market: 'us', label: '美股' }, { market: 'index', label: '股指' }] }),
  watch: { market: { immediate: true, handler() { this.rows = []; this.page = 1; this.load() } } },
  mounted() { this.stopQuotes = pollMarket(async () => {
    if (this.loading) return
    const version = this.request
    const rows = await refreshWatchlist(this.rows, this.market)
    if (version !== this.request) return
    const updates = new Map(rows.map(item => [item.full_code || item.symbol, item]))
    this.rows = this.rows.map(item => updates.get(item.full_code || item.symbol) || item)
  }, () => this.market) },
  beforeDestroy() { this.request++; if (this.stopQuotes) this.stopQuotes() },
  methods: {
    price: quotePrice,
    percent: quotePercent,
    async load(more = false) {
    more = more === true
    const request = ++this.request
    this.loading = true; this.error = ''
    if (!more) { this.rows = []; this.page = 1 }
    if (this.market === 'index' || !getToken()) { this.hasMore = false; this.loading = false; this.error = this.market === 'index' ? '股指自选组件待开发' : '请先登录查看自选股票'; return }
    try {
      const result = await optionalNewApi({ type: { cn: 0, hk: 1, us: 2, index: -8 }[this.market], page: this.page, limit: 20 })
      if (request !== this.request) return
      if (!result || !Array.isArray(result.data)) throw new Error('invalid watchlist')
      this.rows = this.rows.concat(result.data); this.hasMore = this.page < Number(result.last_page || 1); this.page++
    } catch (_) { if (request === this.request) this.error = '自选加载失败' }
    finally { if (request === this.request) this.loading = false }
  } }
}
</script>
<style scoped>
header, nav { height: 36px; line-height: 36px; background: var(--theme-header); } header { padding: 0 13px; } nav { display: flex; } button { font: inherit; color: inherit; border: 0; background: transparent; cursor: pointer; } nav button { flex: 1; } nav .active { color: var(--theme-text); border-bottom: 2px solid currentColor; } .list-row { display: grid; grid-template-columns: minmax(0, 2fr) 1fr 1fr; width: 100%; min-height: 36px; align-items: center; padding: 0 4px; text-align: right; } .list-row span:first-child { text-align: left; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; } .list-row.active { background: var(--theme-hover); } p { padding: 12px; } .rise { color: var(--quote-up); } .fall { color: var(--quote-down); }
</style>
